import React, { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequests from "../../../utils/useRequests";
import Snackbars from "../../../utils/Snackbars";
import * as Yup from "yup";
import { useFormik } from "formik";

const ChangePassword = () => {
    const navigate = useNavigate();
    const {postRequest} = useRequests(); 
    const [formData, setFormData] = useState({
        old_password: "",
        new_password: "",
        new_confirm_password: "",
    });
    const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
      });
    
      const resetAlertData = () => {
        setTimeout(() => {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: '',
            message: '',
          }));
        }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
      };
   

    const validation1 = useFormik({
        enableReinitialize: true,
    
        initialValues: {
          old_password: '',
          new_password: '',
          new_confirm_password: '',
        },
        validationSchema: Yup.object({
          old_password: Yup.string()
             .required('Old password is required'),
          new_password: Yup.string()
            .required('New password is required')
            .min(8, "Password must be at least 8 characters long!")
            .max(20, "Password must not exceed 20 characters!"),
          new_confirm_password: Yup.string()
            .required('Confirm new password')
            .oneOf([Yup.ref("new_password"), null], "Passwords must match!")
        }),
    onSubmit: async (values) => {
        // e.preventDefault();
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = ('Processing...');

        if (formData.new_password !== formData.new_confirm_password) {
            
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: 'New Password and Confirm Password do not match.',
              }));
            resetAlertData();
            return;
        }
        try {
            const jsonpar = JSON.stringify({
                old_password: values.old_password,
                new_password: values.new_password,
                new_confirm_password: values.new_confirm_password
            });

            const res = await postRequest("profile-change-password", jsonpar);

            if (res && res.code === 200) {
                setFormData({
                    old_password: "",
                    new_password: "",
                    new_confirm_password: "",
                });
                navigate('/dashboard',{
                    state:{
                        variant: "success",
                        message: "Password updated successfully!",
                    }
                })
               
                
            } else {
               
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: res.message || "Failed to update password.",
                  }));
                resetAlertData();
            }
            submit1.disabled = false;
            submit1.textContent = (' Update Password');
        } catch (error) {
            console.error("Error: ", error);
            
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: 'An error occurred while updating the password.',
              }));
            resetAlertData();
        }
    }
});

    return (
        <Fragment>
            <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
                <h2 className="text-black font-w700 mb-0">Change Password</h2>
            </div>

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="basic-form">
                           {AlertData.message !== "" ? (
                                     <Snackbars variant={AlertData.variant} message={AlertData.message} />
                                   ) : (
                                     ""
                                   )}
                            <form >
                                <div className="row mb-3">
                                    <div className="form-group mb-3 col-md-6 col-xs-12">
                                        <label>Old Password :</label>
                                        <input
                                            type="password"
                                            name="old_password"
                                            placeholder="Please Enter Old Password"
                                            className={`form-control ${validation1.touched.old_password && validation1.errors.old_password ? 'is-invalid' : ''}`}
                                            value={validation1.values.old_password || ""}
                                            // onChange={(e) => setEmail(e.target.value)}
                                            onChange={validation1.handleChange}
                                            onBlur={validation1.handleBlur}
                                            invalid={
                                              validation1.touched.old_password && validation1.errors.old_password ? true : false
                                            }
                                            // style={{borderColor:'red'}}
                
                                          />
                                          {validation1.touched.old_password && validation1.errors.old_password ? (
                                            <div className="invalid-feedback" >{validation1.errors.old_password}</div>
                                          ) : null}
                                    </div>
                                    <div className="form-group mb-3 col-md-6 col-xs-12">
                                        <label>New Password :</label>
                                        <input
                                            type="password"
                                            name="new_password"
                                            placeholder="Please Enter New Password"
                                            className={`form-control ${validation1.touched.new_password && validation1.errors.new_password ? 'is-invalid' : ''}`}
                                            value={validation1.values.new_password || ""}
                                            // onChange={(e) => setEmail(e.target.value)}
                                            onChange={validation1.handleChange}
                                            onBlur={validation1.handleBlur}
                                            invalid={
                                              validation1.touched.new_password && validation1.errors.new_password ? true : false
                                            }
                                            // style={{borderColor:'red'}}
                
                                          />
                                          {validation1.touched.new_password && validation1.errors.new_password ? (
                                            <div className="invalid-feedback" >{validation1.errors.new_password}</div>
                                          ) : null}
                                       
                                    </div>
                                    <div className="form-group mb-3 col-md-6 col-xs-12">
                                        <label>Confirm Password :</label>
                                        <input
                                            type="password"
                                            name="new_confirm_password"
                                            placeholder="Please Confirm New Password"
                                            className={`form-control ${validation1.touched.new_confirm_password && validation1.errors.new_confirm_password ? 'is-invalid' : ''}`}
                                            value={validation1.values.new_confirm_password || ""}
                                            // onChange={(e) => setEmail(e.target.value)}
                                            onChange={validation1.handleChange}
                                            onBlur={validation1.handleBlur}
                                            invalid={
                                            validation1.touched.new_confirm_password && validation1.errors.new_confirm_password ? true : false
                                            }
                                            // style={{borderColor:'red'}}

                                        />
                                        {validation1.touched.new_confirm_password && validation1.errors.new_confirm_password ? (
                                            <div className="invalid-feedback" >{validation1.errors.new_confirm_password}</div>
                                        ) : null}
                                    </div>
                                    {/* <Link className='mt-2 float-end mb-4' to="/forgot-password">Forget Password?</Link> */}
                                </div>
                                <button type="submit" className="btn btn-primary me-2"id='submit1' 
                                onClick={(e) => {
                                    e.preventDefault();
                                    validation1.handleSubmit();
                                    return false;
                                  }} >
                                {('Update Password')}
                                </button>
                                <Link to="/dashboard" className="btn btn-light">
                                    Cancel
                                </Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ChangePassword;
